import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { useSnackbar } from "../../../context/SnackBarContext";
import fetcher from "../../../helper/fetcher";

export default function ResetPasswordOtp({ email, onNext, onBack }) {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const { showSuccess, showError } = useSnackbar();

  const handleChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length < 6) {
      showError("Please enter a 6-digit OTP");
      return;
    }

    fetcher
      .post("/crm/auth/verify_otp", { email, otp: otpValue })
      .then((res) => {
        if (res.data.success) {
          showSuccess(res.data.message || "OTP verified!");
          onNext();
        } else {
          showError(res.data.message || "Invalid OTP");
        }
      })
      .catch((err) => {
        showError(err.response?.data?.message || "Server error");
      })
      .finally(() => {
        console.log("OTP verification request finished");
      });
  };



  return (
    <div className="flex items-center justify-center bg-[#f4f5f7]">
      <div className="w-full max-w-md px-6 py-10">
        <div className="flex justify-center mb-6">
          <RiShieldKeyholeLine className="w-20 h-20 text-[#0a3021]" />
        </div>

        <h1 className="text-2xl font-semibold text-center text-[#145348]">
          Enter OTP
        </h1>
        <p className="text-center text-gray-500 text-sm mt-2">
          We’ve sent a 6-digit OTP to your email. Please enter it below.
        </p>

        <form onSubmit={handleSubmit} className="mt-6">
          <div className="flex justify-between gap-2">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="w-12 h-12 border border-gray-300 rounded text-center text-lg focus:outline-none focus:border-[#0a3021]"
              />
            ))}
          </div>

          <button
            type="submit"
            className="w-full mt-6 bg-[#0a3021] text-white font-semibold py-2 rounded transition cursor-pointer"
          >
            Verify OTP
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={onBack || (() => navigate("/crm/login"))}
            className="text-gray-700 text-sm flex items-center justify-center gap-2 hover:underline cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to Email
          </button>
        </div>
      </div>
    </div>
  );
}
